import LiquifiNoticePage from '../pages/liquifi-notice-page.vue'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'

const ensureWorkspace = async (slug: string) => {
  const workspaceStore = useWorkspaceStore()
  if (workspaceStore.current.subdomain !== slug) {
    try {
      await workspaceStore.fetchCurrent(slug)
    } catch {
      workspaceStore.reset()
    }
  }
  return workspaceStore
}

export default [
  {
    component: LiquifiNoticePage,
    name: 'connecting.liquifi',
    path: '/:slug/connecting/liquifi',
    beforeEnter: async (to) => {
      const slug = to.params.slug as string
      const workspaceStore = await ensureWorkspace(slug)
      if (workspaceStore.current.options.has_connections_access) return true

      const authStore = useAuthStore()
      if (slug === 'connections' && authStore.isInvestor) {
        const homeSlug = (authStore.current_user.groups ?? []).find(
          (g: any) => g.subdomain && g.subdomain !== 'connections',
        )?.subdomain

        return {
          name: 'investing.individual-overview',
          params: { slug: homeSlug || slug, individual_id: authStore.current_user.investor_id },
        }
      }
      return { name: 'dashboard', params: { slug } }
    },
  },
  {
    path: '/:slug/connecting/:pathMatch(.*)*',
    redirect: (to) => ({ name: 'connecting.liquifi', params: { slug: to.params.slug } }),
  },
]
